module.exports = __webpack_public_path__ + "media/images/top/top/bg_hero_sp-d5ad931d23e52b81abbad491f064413c.png";